import { ProductType } from 'constants/productType';
import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Caption } from 'views/mutual/caption';
import { Description, labelColor, labelSize } from 'views/mutual/description';

type QuestionStartPageProps = {
  assetType: ProductType;
  onSubmit: () => void;
};

export const QuestionStartPage = (props: QuestionStartPageProps) => {
  const label = (() => {
    switch (props.assetType) {
      case ProductType.LeaseFund:
        return `適合性チェックとは
・日本型オペレーティング・リース事業へのご投資にあたり、いくつかご質問させていただくことで、お客様の知識、経験、財産の状況、投資の目的等に照らして、お客様にふさわしい投資となっているかを確認させていただくものです。そのため確認した結果、お客様のご意向に沿いかねる結果となることもございますので予めご承知おきください。
・適合性チェックの回答はいつでも変更できるようになっております。ご回答いただいた内容が変化した場合には、都度実施いただくようにお願いいたします。
・適合性チェックの有効期限は、オンライン取引サービス、オンライン取引サービス以外でのお取引を問わず、貴社が最後に実施された適合性チェックの完了から1年間となりますので、有効期限が切れていた場合は改めてご回答いただきますようお願いいたします。`;
      case ProductType.DomesticRealEstate:
        return `適合性チェックとは
・国内不動産信託受益権（以下、本信託受益権と言います。）へのご投資にあたり、いくつかご質問させていただくことで、お客様の知識、経験、財産の状況、投資の目的等に照らして、お客様にふさわしい投資となっているかを確認させていただくものです。確認した結果、お客様のご意向に沿いかねる結果となることもございますので予めご承知おきください。
・適合性チェックの回答はいつでも変更できるようになっております。ご回答いただいた内容に変更が生じた場合には、都度実施いただくようにお願いいたします。
・適合性チェックの有効期限は、オンライン取引サービス、オンライン取引サービス以外でのお取引を問わず、お客様が最後に実施された適合性チェックの完了から1年間となりますので、有効期限が切れた場合は改めてご回答いただきますようお願いいたします。`;
      case ProductType.OverseasRealEstate:
        return `適合性チェックとは
・海外不動産投資事業組合（以下、本組合）へのご投資にあたり、いくつかご質問させていただくことで、お客様の知識、経験、財産の状況、投資の目的等に照らして、お客様にふさわしい投資となっているかを確認させていただくものです。確認した結果、お客様のご意向に沿いかねる結果となることもございますので予めご承知おきください。
・適合性チェックの回答はいつでも変更できるようになっております。ご回答いただいた内容に変更が生じた場合には、都度実施いただくようにお願いいたします。
・適合性チェックの有効期限は、オンライン取引サービス、オンライン取引サービス以外でのお取引を問わず、貴社が最後に実施された適合性チェックの完了から1年間となりますので、有効期限が切れた場合は改めてご回答いただきますようお願いいたします。`;
    }
  })();
  return (
    <>
      <div className="compatibilityCheck">
        <Caption label="適合性チェックの概要" />
        <Description label={label} labelColor={labelColor.black} labelSize={labelSize.medium} />
        <Button
          type={ButtonType.Submit}
          label="回答を始める"
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
          onClick={props.onSubmit}
        />
      </div>
    </>
  );
};
